import { Drawer } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Container} {
    width: 1000px;
  }

  ${Drawer.Styled.Body} {
    overflow-y: clip;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 15px;
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 8px;
`;
